import tealiumTrackingModel from "../model/tealiumTrackingModel";

import config from "../../config/config";

let allClickEvents = [];

const sendTracking = (tracking, pageObject, event) => {
	let target = event.target;
	let clickData = { href: null, text: null };
	if (target.href) clickData.href = target.href;
	else if (target.dataset && target.dataset.href) clickData.href = target.dataset.href;
	if (target.innerText && target.innerText !== "") clickData.text = target.innerText;
	tealiumTrackingModel(tracking, pageObject[config.vuePageObject], true, clickData);
};

export default (elements, tracking, useTealiumTracking, pageObject) => {
	if (useTealiumTracking) {
		// Tracking through Tealium and Analytics.
		elements.map((element) => {
			allClickEvents.map((e) => {
				element.removeEventListener("click", e); // Remove if old click tracking is already setup, to not preform double tracking
			});
			allClickEvents.push(sendTracking.bind(this, tracking, pageObject));
			element.addEventListener("click", allClickEvents[allClickEvents.length - 1]);
		});
	} else {
		/* Tracking through own server - Scrapped but might use later (if group needs it)
            element[0].addEventListener("click", (event) => {
                axios.post(config.customTrackingServer+"/click", customTrackingModel(pageObject[config.vuePageObject], true));
            });
         */
	}
};
